import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58f0b4fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pulsating-circle" }, null, -1))

import {useGeolocation} from "@vueuse/core";
import { MapboxMarker } from '@studiometa/vue-mapbox-gl';
import { storeToRefs } from "pinia";
import { useUiStore } from "@/store/ui-store";
import { useUserLocationStore } from "@/store/user-location-store";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLocationMarker',
  setup(__props) {

const { coords } = useGeolocation()

const {
  getShowUserLocationPin
} = storeToRefs(useUiStore())

const { getUserLocationPinStyle, getUserLocationIsValid } = storeToRefs(useUserLocationStore())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(getUserLocationIsValid) && _unref(getShowUserLocationPin))
      ? (_openBlock(), _createBlock(_unref(MapboxMarker), {
          key: 0,
          "lng-lat": [_unref(coords).longitude, _unref(coords).latitude]
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              height: "50",
              width: "50",
              src: "/misc/long-arrow-up.png",
              style: _normalizeStyle(_unref(getUserLocationPinStyle)),
              class: "arrow-marker"
            }, null, 4)
          ]),
          _: 1
        }, 8, ["lng-lat"]))
      : _createCommentVNode("", true),
    (_unref(getUserLocationIsValid) && _unref(getShowUserLocationPin))
      ? (_openBlock(), _createBlock(_unref(MapboxMarker), {
          key: 1,
          "lng-lat": [_unref(coords).longitude, _unref(coords).latitude]
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["lng-lat"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})